/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedConsumerRouteImport } from './routes/_protected/_consumer'
import { Route as ProtectedAdminRouteImport } from './routes/_protected/admin'
import { Route as ProtectedConsumerIndexRouteImport } from './routes/_protected/_consumer/index'
import { Route as ProtectedAdminIndexRouteImport } from './routes/_protected/admin/index'
import { Route as ProtectedAdminInternalToolsRouteImport } from './routes/_protected/admin/internal-tools'
import { Route as JoinCodeIndexRouteImport } from './routes/join/$code/index'
import { Route as ProtectedConsumerActivityIndexRouteImport } from './routes/_protected/_consumer/activity/index'
import { Route as ProtectedConsumerApiTestProofIndexRouteImport } from './routes/_protected/_consumer/api-test-proof/index'
import { Route as ProtectedConsumerChatIndexRouteImport } from './routes/_protected/_consumer/chat/index'
import { Route as ProtectedConsumerConnectAccountConsentIndexRouteImport } from './routes/_protected/_consumer/connect-account-consent/index'
import { Route as ProtectedConsumerIdentityVerificationIndexRouteImport } from './routes/_protected/_consumer/identity-verification/index'
import { Route as ProtectedConsumerInsightsIndexRouteImport } from './routes/_protected/_consumer/insights/index'
import { Route as ProtectedConsumerManageAccountsIndexRouteImport } from './routes/_protected/_consumer/manage-accounts/index'
import { Route as ProtectedConsumerReferFriendsIndexRouteImport } from './routes/_protected/_consumer/refer-friends/index'
import { Route as ProtectedConsumerResourcesIndexRouteImport } from './routes/_protected/_consumer/resources/index'
import { Route as ProtectedConsumerTransactionAnalyticsIndexRouteImport } from './routes/_protected/_consumer/transaction-analytics/index'
import { Route as ProtectedConsumerTransactionOverviewIndexRouteImport } from './routes/_protected/_consumer/transaction-overview/index'
import { Route as ProtectedConsumerUploadSuccessIndexRouteImport } from './routes/_protected/_consumer/upload-success/index'
import { Route as ProtectedConsumerWalletIndexRouteImport } from './routes/_protected/_consumer/wallet/index'
import { Route as ProtectedAdminBenefitsIndexRouteImport } from './routes/_protected/admin/benefits/index'
import { Route as ProtectedAdminInternalToolsIndexRouteImport } from './routes/_protected/admin/internal-tools/index'
import { Route as ProtectedAdminLoyaltyIndexRouteImport } from './routes/_protected/admin/loyalty/index'
import { Route as ProtectedAdminUsersIndexRouteImport } from './routes/_protected/admin/users/index'
import { Route as ProtectedAdminUsersUserIdRouteImport } from './routes/_protected/admin/users/$userId'
import { Route as ProtectedReceiptsCaptureIndexRouteImport } from './routes/_protected/receipts/capture/index'
import { Route as ProtectedConsumerAccountAccountIdIndexRouteImport } from './routes/_protected/_consumer/account/$accountId/index'
import { Route as ProtectedConsumerChatConversationIdIndexRouteImport } from './routes/_protected/_consumer/chat/$conversationId/index'
import { Route as ProtectedConsumerReceiptsReceiptIdIndexRouteImport } from './routes/_protected/_consumer/receipts/$receiptId/index'
import { Route as ProtectedConsumerReferFriendsCodeIndexRouteImport } from './routes/_protected/_consumer/refer-friends/code/index'
import { Route as ProtectedConsumerResourcesProgramIdIndexRouteImport } from './routes/_protected/_consumer/resources/$programId/index'
import { Route as ProtectedConsumerTransactionOverviewTransfersIndexRouteImport } from './routes/_protected/_consumer/transaction-overview/transfers/index'
import { Route as ProtectedConsumerWalletDollarsIndexRouteImport } from './routes/_protected/_consumer/wallet/dollars/index'
import { Route as ProtectedConsumerWalletPointsIndexRouteImport } from './routes/_protected/_consumer/wallet/points/index'
import { Route as ProtectedAdminBenefitsBenefitIdIndexRouteImport } from './routes/_protected/admin/benefits/$benefitId/index'
import { Route as ProtectedAdminBenefitsAddIndexRouteImport } from './routes/_protected/admin/benefits/add/index'
import { Route as ProtectedAdminInternalToolsBenefitCatalogIndexRouteImport } from './routes/_protected/admin/internal-tools/benefit-catalog/index'
import { Route as ProtectedAdminInternalToolsCategoryAuditIndexRouteImport } from './routes/_protected/admin/internal-tools/category-audit/index'
import { Route as ProtectedAdminInternalToolsChatHistoryIndexRouteImport } from './routes/_protected/admin/internal-tools/chat-history/index'
import { Route as ProtectedAdminInternalToolsChatPromptEditorIndexRouteImport } from './routes/_protected/admin/internal-tools/chat-prompt-editor/index'
import { Route as ProtectedAdminInternalToolsCustomPointsTransactionIndexRouteImport } from './routes/_protected/admin/internal-tools/custom-points-transaction/index'
import { Route as ProtectedAdminInternalToolsGiftCardRedemptionsIndexRouteImport } from './routes/_protected/admin/internal-tools/gift-card-redemptions/index'
import { Route as ProtectedAdminInternalToolsIdentityVerificationsIndexRouteImport } from './routes/_protected/admin/internal-tools/identity-verifications/index'
import { Route as ProtectedAdminInternalToolsLocalSettingsIndexRouteImport } from './routes/_protected/admin/internal-tools/local-settings/index'
import { Route as ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRouteImport } from './routes/_protected/admin/internal-tools/merchant-descriptor-patterns/index'
import { Route as ProtectedAdminInternalToolsMerchantManagementIndexRouteImport } from './routes/_protected/admin/internal-tools/merchant-management/index'
import { Route as ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRouteImport } from './routes/_protected/admin/internal-tools/receipt-merchant-cleanup/index'
import { Route as ProtectedAdminInternalToolsReceiptsIndexRouteImport } from './routes/_protected/admin/internal-tools/receipts/index'
import { Route as ProtectedAdminInternalToolsReviewReceiptsIndexRouteImport } from './routes/_protected/admin/internal-tools/review-receipts/index'
import { Route as ProtectedAdminLoyaltyLoyaltyIdIndexRouteImport } from './routes/_protected/admin/loyalty/$loyaltyId/index'
import { Route as ProtectedAdminLoyaltyAddIndexRouteImport } from './routes/_protected/admin/loyalty/add/index'
import { Route as ProtectedAdminUsersUserIdIndexRouteImport } from './routes/_protected/admin/users/$userId/index'
import { Route as ProtectedConsumerInsightsCategoryCategoryNameIndexRouteImport } from './routes/_protected/_consumer/insights/category/$categoryName/index'
import { Route as ProtectedConsumerInsightsMerchantMerchantNameIndexRouteImport } from './routes/_protected/_consumer/insights/merchant/$merchantName/index'
import { Route as ProtectedConsumerReceiptsReceiptIdViewImageIndexRouteImport } from './routes/_protected/_consumer/receipts/$receiptId/view-image/index'
import { Route as ProtectedAdminBenefitsBenefitIdEditIndexRouteImport } from './routes/_protected/admin/benefits/$benefitId/edit/index'
import { Route as ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRouteImport } from './routes/_protected/admin/internal-tools/benefit-catalog/$entryId/index'
import { Route as ProtectedAdminInternalToolsBenefitCatalogNewIndexRouteImport } from './routes/_protected/admin/internal-tools/benefit-catalog/new/index'
import { Route as ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRouteImport } from './routes/_protected/admin/internal-tools/chat-history/$chatHistoryId/index'
import { Route as ProtectedAdminInternalToolsLedgerAccountsIndexRouteImport } from './routes/_protected/admin/internal-tools/ledger/accounts/index'
import { Route as ProtectedAdminInternalToolsLedgerNewTransferIndexRouteImport } from './routes/_protected/admin/internal-tools/ledger/new-transfer/index'
import { Route as ProtectedAdminInternalToolsLedgerTransfersIndexRouteImport } from './routes/_protected/admin/internal-tools/ledger/transfers/index'
import { Route as ProtectedAdminInternalToolsReceiptsReceiptIdIndexRouteImport } from './routes/_protected/admin/internal-tools/receipts/$receiptId/index'
import { Route as ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRouteImport } from './routes/_protected/admin/internal-tools/review-receipts/$receiptReviewId/index'
import { Route as ProtectedAdminLoyaltyLoyaltyIdEditIndexRouteImport } from './routes/_protected/admin/loyalty/$loyaltyId/edit/index'
import { Route as ProtectedAdminUsersUserIdConfigureProgramsIndexRouteImport } from './routes/_protected/admin/users/$userId/configure-programs/index'
import { Route as ProtectedAdminUsersUserIdEnrichBalanceIndexRouteImport } from './routes/_protected/admin/users/$userId/enrich-balance/index'
import { Route as ProtectedAdminUsersUserIdEnrichRewardsIndexRouteImport } from './routes/_protected/admin/users/$userId/enrich-rewards/index'
import { Route as ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRouteImport } from './routes/_protected/admin/benefits/$benefitId/users/$userId/index'
import { Route as ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRouteImport } from './routes/_protected/admin/internal-tools/benefit-catalog/$entryId/edit/index'
import { Route as ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRouteImport } from './routes/_protected/admin/internal-tools/ledger/accounts/$accountId/index'
import { Route as ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRouteImport } from './routes/_protected/admin/internal-tools/ledger/transfers/$transferId/index'
import { Route as ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRouteImport } from './routes/_protected/admin/internal-tools/receipts/$receiptId/edit/index'
import { Route as ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRouteImport } from './routes/_protected/admin/internal-tools/review-receipts/$receiptReviewId/edit/index'
import { Route as ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRouteImport } from './routes/_protected/admin/loyalty/$loyaltyId/users/$userId/index'
import { Route as ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRouteImport } from './routes/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/index'
import { Route as ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRouteImport } from './routes/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/index'

const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedConsumerRoute = ProtectedConsumerRouteImport.update({
  id: '/_consumer',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminRoute = ProtectedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedConsumerIndexRoute = ProtectedConsumerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedConsumerRoute,
} as any)
const ProtectedAdminIndexRoute = ProtectedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminInternalToolsRoute =
  ProtectedAdminInternalToolsRouteImport.update({
    id: '/internal-tools',
    path: '/internal-tools',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const JoinCodeIndexRoute = JoinCodeIndexRouteImport.update({
  id: '/join/$code/',
  path: '/join/$code/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedConsumerActivityIndexRoute =
  ProtectedConsumerActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerApiTestProofIndexRoute =
  ProtectedConsumerApiTestProofIndexRouteImport.update({
    id: '/api-test-proof/',
    path: '/api-test-proof/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerChatIndexRoute =
  ProtectedConsumerChatIndexRouteImport.update({
    id: '/chat/',
    path: '/chat/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerConnectAccountConsentIndexRoute =
  ProtectedConsumerConnectAccountConsentIndexRouteImport.update({
    id: '/connect-account-consent/',
    path: '/connect-account-consent/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerIdentityVerificationIndexRoute =
  ProtectedConsumerIdentityVerificationIndexRouteImport.update({
    id: '/identity-verification/',
    path: '/identity-verification/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerInsightsIndexRoute =
  ProtectedConsumerInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerManageAccountsIndexRoute =
  ProtectedConsumerManageAccountsIndexRouteImport.update({
    id: '/manage-accounts/',
    path: '/manage-accounts/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerReferFriendsIndexRoute =
  ProtectedConsumerReferFriendsIndexRouteImport.update({
    id: '/refer-friends/',
    path: '/refer-friends/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerResourcesIndexRoute =
  ProtectedConsumerResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerTransactionAnalyticsIndexRoute =
  ProtectedConsumerTransactionAnalyticsIndexRouteImport.update({
    id: '/transaction-analytics/',
    path: '/transaction-analytics/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerTransactionOverviewIndexRoute =
  ProtectedConsumerTransactionOverviewIndexRouteImport.update({
    id: '/transaction-overview/',
    path: '/transaction-overview/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerUploadSuccessIndexRoute =
  ProtectedConsumerUploadSuccessIndexRouteImport.update({
    id: '/upload-success/',
    path: '/upload-success/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerWalletIndexRoute =
  ProtectedConsumerWalletIndexRouteImport.update({
    id: '/wallet/',
    path: '/wallet/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedAdminBenefitsIndexRoute =
  ProtectedAdminBenefitsIndexRouteImport.update({
    id: '/benefits/',
    path: '/benefits/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminInternalToolsIndexRoute =
  ProtectedAdminInternalToolsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminLoyaltyIndexRoute =
  ProtectedAdminLoyaltyIndexRouteImport.update({
    id: '/loyalty/',
    path: '/loyalty/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminUsersIndexRoute =
  ProtectedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminUsersUserIdRoute =
  ProtectedAdminUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedReceiptsCaptureIndexRoute =
  ProtectedReceiptsCaptureIndexRouteImport.update({
    id: '/receipts/capture/',
    path: '/receipts/capture/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedConsumerAccountAccountIdIndexRoute =
  ProtectedConsumerAccountAccountIdIndexRouteImport.update({
    id: '/account/$accountId/',
    path: '/account/$accountId/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerChatConversationIdIndexRoute =
  ProtectedConsumerChatConversationIdIndexRouteImport.update({
    id: '/chat/$conversationId/',
    path: '/chat/$conversationId/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerReceiptsReceiptIdIndexRoute =
  ProtectedConsumerReceiptsReceiptIdIndexRouteImport.update({
    id: '/receipts/$receiptId/',
    path: '/receipts/$receiptId/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerReferFriendsCodeIndexRoute =
  ProtectedConsumerReferFriendsCodeIndexRouteImport.update({
    id: '/refer-friends/code/',
    path: '/refer-friends/code/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerResourcesProgramIdIndexRoute =
  ProtectedConsumerResourcesProgramIdIndexRouteImport.update({
    id: '/resources/$programId/',
    path: '/resources/$programId/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerTransactionOverviewTransfersIndexRoute =
  ProtectedConsumerTransactionOverviewTransfersIndexRouteImport.update({
    id: '/transaction-overview/transfers/',
    path: '/transaction-overview/transfers/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerWalletDollarsIndexRoute =
  ProtectedConsumerWalletDollarsIndexRouteImport.update({
    id: '/wallet/dollars/',
    path: '/wallet/dollars/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerWalletPointsIndexRoute =
  ProtectedConsumerWalletPointsIndexRouteImport.update({
    id: '/wallet/points/',
    path: '/wallet/points/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedAdminBenefitsBenefitIdIndexRoute =
  ProtectedAdminBenefitsBenefitIdIndexRouteImport.update({
    id: '/benefits/$benefitId/',
    path: '/benefits/$benefitId/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminBenefitsAddIndexRoute =
  ProtectedAdminBenefitsAddIndexRouteImport.update({
    id: '/benefits/add/',
    path: '/benefits/add/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminInternalToolsBenefitCatalogIndexRoute =
  ProtectedAdminInternalToolsBenefitCatalogIndexRouteImport.update({
    id: '/benefit-catalog/',
    path: '/benefit-catalog/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsCategoryAuditIndexRoute =
  ProtectedAdminInternalToolsCategoryAuditIndexRouteImport.update({
    id: '/category-audit/',
    path: '/category-audit/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsChatHistoryIndexRoute =
  ProtectedAdminInternalToolsChatHistoryIndexRouteImport.update({
    id: '/chat-history/',
    path: '/chat-history/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsChatPromptEditorIndexRoute =
  ProtectedAdminInternalToolsChatPromptEditorIndexRouteImport.update({
    id: '/chat-prompt-editor/',
    path: '/chat-prompt-editor/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute =
  ProtectedAdminInternalToolsCustomPointsTransactionIndexRouteImport.update({
    id: '/custom-points-transaction/',
    path: '/custom-points-transaction/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute =
  ProtectedAdminInternalToolsGiftCardRedemptionsIndexRouteImport.update({
    id: '/gift-card-redemptions/',
    path: '/gift-card-redemptions/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsIdentityVerificationsIndexRoute =
  ProtectedAdminInternalToolsIdentityVerificationsIndexRouteImport.update({
    id: '/identity-verifications/',
    path: '/identity-verifications/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsLocalSettingsIndexRoute =
  ProtectedAdminInternalToolsLocalSettingsIndexRouteImport.update({
    id: '/local-settings/',
    path: '/local-settings/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute =
  ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRouteImport.update({
    id: '/merchant-descriptor-patterns/',
    path: '/merchant-descriptor-patterns/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsMerchantManagementIndexRoute =
  ProtectedAdminInternalToolsMerchantManagementIndexRouteImport.update({
    id: '/merchant-management/',
    path: '/merchant-management/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute =
  ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRouteImport.update({
    id: '/receipt-merchant-cleanup/',
    path: '/receipt-merchant-cleanup/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReceiptsIndexRoute =
  ProtectedAdminInternalToolsReceiptsIndexRouteImport.update({
    id: '/receipts/',
    path: '/receipts/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReviewReceiptsIndexRoute =
  ProtectedAdminInternalToolsReviewReceiptsIndexRouteImport.update({
    id: '/review-receipts/',
    path: '/review-receipts/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminLoyaltyLoyaltyIdIndexRoute =
  ProtectedAdminLoyaltyLoyaltyIdIndexRouteImport.update({
    id: '/loyalty/$loyaltyId/',
    path: '/loyalty/$loyaltyId/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminLoyaltyAddIndexRoute =
  ProtectedAdminLoyaltyAddIndexRouteImport.update({
    id: '/loyalty/add/',
    path: '/loyalty/add/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminUsersUserIdIndexRoute =
  ProtectedAdminUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAdminUsersUserIdRoute,
  } as any)
const ProtectedConsumerInsightsCategoryCategoryNameIndexRoute =
  ProtectedConsumerInsightsCategoryCategoryNameIndexRouteImport.update({
    id: '/insights/category/$categoryName/',
    path: '/insights/category/$categoryName/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerInsightsMerchantMerchantNameIndexRoute =
  ProtectedConsumerInsightsMerchantMerchantNameIndexRouteImport.update({
    id: '/insights/merchant/$merchantName/',
    path: '/insights/merchant/$merchantName/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute =
  ProtectedConsumerReceiptsReceiptIdViewImageIndexRouteImport.update({
    id: '/receipts/$receiptId/view-image/',
    path: '/receipts/$receiptId/view-image/',
    getParentRoute: () => ProtectedConsumerRoute,
  } as any)
const ProtectedAdminBenefitsBenefitIdEditIndexRoute =
  ProtectedAdminBenefitsBenefitIdEditIndexRouteImport.update({
    id: '/benefits/$benefitId/edit/',
    path: '/benefits/$benefitId/edit/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute =
  ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRouteImport.update({
    id: '/benefit-catalog/$entryId/',
    path: '/benefit-catalog/$entryId/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute =
  ProtectedAdminInternalToolsBenefitCatalogNewIndexRouteImport.update({
    id: '/benefit-catalog/new/',
    path: '/benefit-catalog/new/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute =
  ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRouteImport.update({
    id: '/chat-history/$chatHistoryId/',
    path: '/chat-history/$chatHistoryId/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsLedgerAccountsIndexRoute =
  ProtectedAdminInternalToolsLedgerAccountsIndexRouteImport.update({
    id: '/ledger/accounts/',
    path: '/ledger/accounts/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsLedgerNewTransferIndexRoute =
  ProtectedAdminInternalToolsLedgerNewTransferIndexRouteImport.update({
    id: '/ledger/new-transfer/',
    path: '/ledger/new-transfer/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsLedgerTransfersIndexRoute =
  ProtectedAdminInternalToolsLedgerTransfersIndexRouteImport.update({
    id: '/ledger/transfers/',
    path: '/ledger/transfers/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute =
  ProtectedAdminInternalToolsReceiptsReceiptIdIndexRouteImport.update({
    id: '/receipts/$receiptId/',
    path: '/receipts/$receiptId/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute =
  ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRouteImport.update(
    {
      id: '/review-receipts/$receiptReviewId/',
      path: '/review-receipts/$receiptReviewId/',
      getParentRoute: () => ProtectedAdminInternalToolsRoute,
    } as any,
  )
const ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute =
  ProtectedAdminLoyaltyLoyaltyIdEditIndexRouteImport.update({
    id: '/loyalty/$loyaltyId/edit/',
    path: '/loyalty/$loyaltyId/edit/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminUsersUserIdConfigureProgramsIndexRoute =
  ProtectedAdminUsersUserIdConfigureProgramsIndexRouteImport.update({
    id: '/configure-programs/',
    path: '/configure-programs/',
    getParentRoute: () => ProtectedAdminUsersUserIdRoute,
  } as any)
const ProtectedAdminUsersUserIdEnrichBalanceIndexRoute =
  ProtectedAdminUsersUserIdEnrichBalanceIndexRouteImport.update({
    id: '/enrich-balance/',
    path: '/enrich-balance/',
    getParentRoute: () => ProtectedAdminUsersUserIdRoute,
  } as any)
const ProtectedAdminUsersUserIdEnrichRewardsIndexRoute =
  ProtectedAdminUsersUserIdEnrichRewardsIndexRouteImport.update({
    id: '/enrich-rewards/',
    path: '/enrich-rewards/',
    getParentRoute: () => ProtectedAdminUsersUserIdRoute,
  } as any)
const ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute =
  ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRouteImport.update({
    id: '/benefits/$benefitId/users/$userId/',
    path: '/benefits/$benefitId/users/$userId/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute =
  ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRouteImport.update({
    id: '/benefit-catalog/$entryId/edit/',
    path: '/benefit-catalog/$entryId/edit/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute =
  ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRouteImport.update({
    id: '/ledger/accounts/$accountId/',
    path: '/ledger/accounts/$accountId/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute =
  ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRouteImport.update({
    id: '/ledger/transfers/$transferId/',
    path: '/ledger/transfers/$transferId/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute =
  ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRouteImport.update({
    id: '/receipts/$receiptId/edit/',
    path: '/receipts/$receiptId/edit/',
    getParentRoute: () => ProtectedAdminInternalToolsRoute,
  } as any)
const ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute =
  ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRouteImport.update(
    {
      id: '/review-receipts/$receiptReviewId/edit/',
      path: '/review-receipts/$receiptReviewId/edit/',
      getParentRoute: () => ProtectedAdminInternalToolsRoute,
    } as any,
  )
const ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute =
  ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRouteImport.update({
    id: '/loyalty/$loyaltyId/users/$userId/',
    path: '/loyalty/$loyaltyId/users/$userId/',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute =
  ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRouteImport.update(
    {
      id: '/benefit-catalog/$entryId/revisions/$revisionNumber/',
      path: '/benefit-catalog/$entryId/revisions/$revisionNumber/',
      getParentRoute: () => ProtectedAdminInternalToolsRoute,
    } as any,
  )
const ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute =
  ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRouteImport.update(
    {
      id: '/benefit-catalog/$entryId/revisions/$revisionNumber/edit/',
      path: '/benefit-catalog/$entryId/revisions/$revisionNumber/edit/',
      getParentRoute: () => ProtectedAdminInternalToolsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof ProtectedConsumerIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof ProtectedAdminRouteWithChildren
  '/admin/internal-tools': typeof ProtectedAdminInternalToolsRouteWithChildren
  '/admin/': typeof ProtectedAdminIndexRoute
  '/join/$code/': typeof JoinCodeIndexRoute
  '/admin/users/$userId': typeof ProtectedAdminUsersUserIdRouteWithChildren
  '/activity/': typeof ProtectedConsumerActivityIndexRoute
  '/api-test-proof/': typeof ProtectedConsumerApiTestProofIndexRoute
  '/chat/': typeof ProtectedConsumerChatIndexRoute
  '/connect-account-consent/': typeof ProtectedConsumerConnectAccountConsentIndexRoute
  '/identity-verification/': typeof ProtectedConsumerIdentityVerificationIndexRoute
  '/insights/': typeof ProtectedConsumerInsightsIndexRoute
  '/manage-accounts/': typeof ProtectedConsumerManageAccountsIndexRoute
  '/refer-friends/': typeof ProtectedConsumerReferFriendsIndexRoute
  '/resources/': typeof ProtectedConsumerResourcesIndexRoute
  '/transaction-analytics/': typeof ProtectedConsumerTransactionAnalyticsIndexRoute
  '/transaction-overview/': typeof ProtectedConsumerTransactionOverviewIndexRoute
  '/upload-success/': typeof ProtectedConsumerUploadSuccessIndexRoute
  '/wallet/': typeof ProtectedConsumerWalletIndexRoute
  '/admin/benefits/': typeof ProtectedAdminBenefitsIndexRoute
  '/admin/internal-tools/': typeof ProtectedAdminInternalToolsIndexRoute
  '/admin/loyalty/': typeof ProtectedAdminLoyaltyIndexRoute
  '/admin/users/': typeof ProtectedAdminUsersIndexRoute
  '/receipts/capture/': typeof ProtectedReceiptsCaptureIndexRoute
  '/account/$accountId/': typeof ProtectedConsumerAccountAccountIdIndexRoute
  '/chat/$conversationId/': typeof ProtectedConsumerChatConversationIdIndexRoute
  '/receipts/$receiptId/': typeof ProtectedConsumerReceiptsReceiptIdIndexRoute
  '/refer-friends/code/': typeof ProtectedConsumerReferFriendsCodeIndexRoute
  '/resources/$programId/': typeof ProtectedConsumerResourcesProgramIdIndexRoute
  '/transaction-overview/transfers/': typeof ProtectedConsumerTransactionOverviewTransfersIndexRoute
  '/wallet/dollars/': typeof ProtectedConsumerWalletDollarsIndexRoute
  '/wallet/points/': typeof ProtectedConsumerWalletPointsIndexRoute
  '/admin/benefits/$benefitId/': typeof ProtectedAdminBenefitsBenefitIdIndexRoute
  '/admin/benefits/add/': typeof ProtectedAdminBenefitsAddIndexRoute
  '/admin/internal-tools/benefit-catalog/': typeof ProtectedAdminInternalToolsBenefitCatalogIndexRoute
  '/admin/internal-tools/category-audit/': typeof ProtectedAdminInternalToolsCategoryAuditIndexRoute
  '/admin/internal-tools/chat-history/': typeof ProtectedAdminInternalToolsChatHistoryIndexRoute
  '/admin/internal-tools/chat-prompt-editor/': typeof ProtectedAdminInternalToolsChatPromptEditorIndexRoute
  '/admin/internal-tools/custom-points-transaction/': typeof ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute
  '/admin/internal-tools/gift-card-redemptions/': typeof ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute
  '/admin/internal-tools/identity-verifications/': typeof ProtectedAdminInternalToolsIdentityVerificationsIndexRoute
  '/admin/internal-tools/local-settings/': typeof ProtectedAdminInternalToolsLocalSettingsIndexRoute
  '/admin/internal-tools/merchant-descriptor-patterns/': typeof ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute
  '/admin/internal-tools/merchant-management/': typeof ProtectedAdminInternalToolsMerchantManagementIndexRoute
  '/admin/internal-tools/receipt-merchant-cleanup/': typeof ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute
  '/admin/internal-tools/receipts/': typeof ProtectedAdminInternalToolsReceiptsIndexRoute
  '/admin/internal-tools/review-receipts/': typeof ProtectedAdminInternalToolsReviewReceiptsIndexRoute
  '/admin/loyalty/$loyaltyId/': typeof ProtectedAdminLoyaltyLoyaltyIdIndexRoute
  '/admin/loyalty/add/': typeof ProtectedAdminLoyaltyAddIndexRoute
  '/admin/users/$userId/': typeof ProtectedAdminUsersUserIdIndexRoute
  '/insights/category/$categoryName/': typeof ProtectedConsumerInsightsCategoryCategoryNameIndexRoute
  '/insights/merchant/$merchantName/': typeof ProtectedConsumerInsightsMerchantMerchantNameIndexRoute
  '/receipts/$receiptId/view-image/': typeof ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute
  '/admin/benefits/$benefitId/edit/': typeof ProtectedAdminBenefitsBenefitIdEditIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute
  '/admin/internal-tools/benefit-catalog/new/': typeof ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute
  '/admin/internal-tools/chat-history/$chatHistoryId/': typeof ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute
  '/admin/internal-tools/ledger/accounts/': typeof ProtectedAdminInternalToolsLedgerAccountsIndexRoute
  '/admin/internal-tools/ledger/new-transfer/': typeof ProtectedAdminInternalToolsLedgerNewTransferIndexRoute
  '/admin/internal-tools/ledger/transfers/': typeof ProtectedAdminInternalToolsLedgerTransfersIndexRoute
  '/admin/internal-tools/receipts/$receiptId/': typeof ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute
  '/admin/internal-tools/review-receipts/$receiptReviewId/': typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute
  '/admin/loyalty/$loyaltyId/edit/': typeof ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute
  '/admin/users/$userId/configure-programs/': typeof ProtectedAdminUsersUserIdConfigureProgramsIndexRoute
  '/admin/users/$userId/enrich-balance/': typeof ProtectedAdminUsersUserIdEnrichBalanceIndexRoute
  '/admin/users/$userId/enrich-rewards/': typeof ProtectedAdminUsersUserIdEnrichRewardsIndexRoute
  '/admin/benefits/$benefitId/users/$userId/': typeof ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/edit/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute
  '/admin/internal-tools/ledger/accounts/$accountId/': typeof ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute
  '/admin/internal-tools/ledger/transfers/$transferId/': typeof ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute
  '/admin/internal-tools/receipts/$receiptId/edit/': typeof ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute
  '/admin/internal-tools/review-receipts/$receiptReviewId/edit/': typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute
  '/admin/loyalty/$loyaltyId/users/$userId/': typeof ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof ProtectedConsumerIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof ProtectedAdminIndexRoute
  '/join/$code': typeof JoinCodeIndexRoute
  '/activity': typeof ProtectedConsumerActivityIndexRoute
  '/api-test-proof': typeof ProtectedConsumerApiTestProofIndexRoute
  '/chat': typeof ProtectedConsumerChatIndexRoute
  '/connect-account-consent': typeof ProtectedConsumerConnectAccountConsentIndexRoute
  '/identity-verification': typeof ProtectedConsumerIdentityVerificationIndexRoute
  '/insights': typeof ProtectedConsumerInsightsIndexRoute
  '/manage-accounts': typeof ProtectedConsumerManageAccountsIndexRoute
  '/refer-friends': typeof ProtectedConsumerReferFriendsIndexRoute
  '/resources': typeof ProtectedConsumerResourcesIndexRoute
  '/transaction-analytics': typeof ProtectedConsumerTransactionAnalyticsIndexRoute
  '/transaction-overview': typeof ProtectedConsumerTransactionOverviewIndexRoute
  '/upload-success': typeof ProtectedConsumerUploadSuccessIndexRoute
  '/wallet': typeof ProtectedConsumerWalletIndexRoute
  '/admin/benefits': typeof ProtectedAdminBenefitsIndexRoute
  '/admin/internal-tools': typeof ProtectedAdminInternalToolsIndexRoute
  '/admin/loyalty': typeof ProtectedAdminLoyaltyIndexRoute
  '/admin/users': typeof ProtectedAdminUsersIndexRoute
  '/receipts/capture': typeof ProtectedReceiptsCaptureIndexRoute
  '/account/$accountId': typeof ProtectedConsumerAccountAccountIdIndexRoute
  '/chat/$conversationId': typeof ProtectedConsumerChatConversationIdIndexRoute
  '/receipts/$receiptId': typeof ProtectedConsumerReceiptsReceiptIdIndexRoute
  '/refer-friends/code': typeof ProtectedConsumerReferFriendsCodeIndexRoute
  '/resources/$programId': typeof ProtectedConsumerResourcesProgramIdIndexRoute
  '/transaction-overview/transfers': typeof ProtectedConsumerTransactionOverviewTransfersIndexRoute
  '/wallet/dollars': typeof ProtectedConsumerWalletDollarsIndexRoute
  '/wallet/points': typeof ProtectedConsumerWalletPointsIndexRoute
  '/admin/benefits/$benefitId': typeof ProtectedAdminBenefitsBenefitIdIndexRoute
  '/admin/benefits/add': typeof ProtectedAdminBenefitsAddIndexRoute
  '/admin/internal-tools/benefit-catalog': typeof ProtectedAdminInternalToolsBenefitCatalogIndexRoute
  '/admin/internal-tools/category-audit': typeof ProtectedAdminInternalToolsCategoryAuditIndexRoute
  '/admin/internal-tools/chat-history': typeof ProtectedAdminInternalToolsChatHistoryIndexRoute
  '/admin/internal-tools/chat-prompt-editor': typeof ProtectedAdminInternalToolsChatPromptEditorIndexRoute
  '/admin/internal-tools/custom-points-transaction': typeof ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute
  '/admin/internal-tools/gift-card-redemptions': typeof ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute
  '/admin/internal-tools/identity-verifications': typeof ProtectedAdminInternalToolsIdentityVerificationsIndexRoute
  '/admin/internal-tools/local-settings': typeof ProtectedAdminInternalToolsLocalSettingsIndexRoute
  '/admin/internal-tools/merchant-descriptor-patterns': typeof ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute
  '/admin/internal-tools/merchant-management': typeof ProtectedAdminInternalToolsMerchantManagementIndexRoute
  '/admin/internal-tools/receipt-merchant-cleanup': typeof ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute
  '/admin/internal-tools/receipts': typeof ProtectedAdminInternalToolsReceiptsIndexRoute
  '/admin/internal-tools/review-receipts': typeof ProtectedAdminInternalToolsReviewReceiptsIndexRoute
  '/admin/loyalty/$loyaltyId': typeof ProtectedAdminLoyaltyLoyaltyIdIndexRoute
  '/admin/loyalty/add': typeof ProtectedAdminLoyaltyAddIndexRoute
  '/admin/users/$userId': typeof ProtectedAdminUsersUserIdIndexRoute
  '/insights/category/$categoryName': typeof ProtectedConsumerInsightsCategoryCategoryNameIndexRoute
  '/insights/merchant/$merchantName': typeof ProtectedConsumerInsightsMerchantMerchantNameIndexRoute
  '/receipts/$receiptId/view-image': typeof ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute
  '/admin/benefits/$benefitId/edit': typeof ProtectedAdminBenefitsBenefitIdEditIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute
  '/admin/internal-tools/benefit-catalog/new': typeof ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute
  '/admin/internal-tools/chat-history/$chatHistoryId': typeof ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute
  '/admin/internal-tools/ledger/accounts': typeof ProtectedAdminInternalToolsLedgerAccountsIndexRoute
  '/admin/internal-tools/ledger/new-transfer': typeof ProtectedAdminInternalToolsLedgerNewTransferIndexRoute
  '/admin/internal-tools/ledger/transfers': typeof ProtectedAdminInternalToolsLedgerTransfersIndexRoute
  '/admin/internal-tools/receipts/$receiptId': typeof ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute
  '/admin/internal-tools/review-receipts/$receiptReviewId': typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute
  '/admin/loyalty/$loyaltyId/edit': typeof ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute
  '/admin/users/$userId/configure-programs': typeof ProtectedAdminUsersUserIdConfigureProgramsIndexRoute
  '/admin/users/$userId/enrich-balance': typeof ProtectedAdminUsersUserIdEnrichBalanceIndexRoute
  '/admin/users/$userId/enrich-rewards': typeof ProtectedAdminUsersUserIdEnrichRewardsIndexRoute
  '/admin/benefits/$benefitId/users/$userId': typeof ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/edit': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute
  '/admin/internal-tools/ledger/accounts/$accountId': typeof ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute
  '/admin/internal-tools/ledger/transfers/$transferId': typeof ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute
  '/admin/internal-tools/receipts/$receiptId/edit': typeof ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute
  '/admin/internal-tools/review-receipts/$receiptReviewId/edit': typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute
  '/admin/loyalty/$loyaltyId/users/$userId': typeof ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute
  '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/_protected/_consumer': typeof ProtectedConsumerRouteWithChildren
  '/_protected/admin': typeof ProtectedAdminRouteWithChildren
  '/_protected/admin/internal-tools': typeof ProtectedAdminInternalToolsRouteWithChildren
  '/_protected/_consumer/': typeof ProtectedConsumerIndexRoute
  '/_protected/admin/': typeof ProtectedAdminIndexRoute
  '/join/$code/': typeof JoinCodeIndexRoute
  '/_protected/admin/users/$userId': typeof ProtectedAdminUsersUserIdRouteWithChildren
  '/_protected/_consumer/activity/': typeof ProtectedConsumerActivityIndexRoute
  '/_protected/_consumer/api-test-proof/': typeof ProtectedConsumerApiTestProofIndexRoute
  '/_protected/_consumer/chat/': typeof ProtectedConsumerChatIndexRoute
  '/_protected/_consumer/connect-account-consent/': typeof ProtectedConsumerConnectAccountConsentIndexRoute
  '/_protected/_consumer/identity-verification/': typeof ProtectedConsumerIdentityVerificationIndexRoute
  '/_protected/_consumer/insights/': typeof ProtectedConsumerInsightsIndexRoute
  '/_protected/_consumer/manage-accounts/': typeof ProtectedConsumerManageAccountsIndexRoute
  '/_protected/_consumer/refer-friends/': typeof ProtectedConsumerReferFriendsIndexRoute
  '/_protected/_consumer/resources/': typeof ProtectedConsumerResourcesIndexRoute
  '/_protected/_consumer/transaction-analytics/': typeof ProtectedConsumerTransactionAnalyticsIndexRoute
  '/_protected/_consumer/transaction-overview/': typeof ProtectedConsumerTransactionOverviewIndexRoute
  '/_protected/_consumer/upload-success/': typeof ProtectedConsumerUploadSuccessIndexRoute
  '/_protected/_consumer/wallet/': typeof ProtectedConsumerWalletIndexRoute
  '/_protected/admin/benefits/': typeof ProtectedAdminBenefitsIndexRoute
  '/_protected/admin/internal-tools/': typeof ProtectedAdminInternalToolsIndexRoute
  '/_protected/admin/loyalty/': typeof ProtectedAdminLoyaltyIndexRoute
  '/_protected/admin/users/': typeof ProtectedAdminUsersIndexRoute
  '/_protected/receipts/capture/': typeof ProtectedReceiptsCaptureIndexRoute
  '/_protected/_consumer/account/$accountId/': typeof ProtectedConsumerAccountAccountIdIndexRoute
  '/_protected/_consumer/chat/$conversationId/': typeof ProtectedConsumerChatConversationIdIndexRoute
  '/_protected/_consumer/receipts/$receiptId/': typeof ProtectedConsumerReceiptsReceiptIdIndexRoute
  '/_protected/_consumer/refer-friends/code/': typeof ProtectedConsumerReferFriendsCodeIndexRoute
  '/_protected/_consumer/resources/$programId/': typeof ProtectedConsumerResourcesProgramIdIndexRoute
  '/_protected/_consumer/transaction-overview/transfers/': typeof ProtectedConsumerTransactionOverviewTransfersIndexRoute
  '/_protected/_consumer/wallet/dollars/': typeof ProtectedConsumerWalletDollarsIndexRoute
  '/_protected/_consumer/wallet/points/': typeof ProtectedConsumerWalletPointsIndexRoute
  '/_protected/admin/benefits/$benefitId/': typeof ProtectedAdminBenefitsBenefitIdIndexRoute
  '/_protected/admin/benefits/add/': typeof ProtectedAdminBenefitsAddIndexRoute
  '/_protected/admin/internal-tools/benefit-catalog/': typeof ProtectedAdminInternalToolsBenefitCatalogIndexRoute
  '/_protected/admin/internal-tools/category-audit/': typeof ProtectedAdminInternalToolsCategoryAuditIndexRoute
  '/_protected/admin/internal-tools/chat-history/': typeof ProtectedAdminInternalToolsChatHistoryIndexRoute
  '/_protected/admin/internal-tools/chat-prompt-editor/': typeof ProtectedAdminInternalToolsChatPromptEditorIndexRoute
  '/_protected/admin/internal-tools/custom-points-transaction/': typeof ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute
  '/_protected/admin/internal-tools/gift-card-redemptions/': typeof ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute
  '/_protected/admin/internal-tools/identity-verifications/': typeof ProtectedAdminInternalToolsIdentityVerificationsIndexRoute
  '/_protected/admin/internal-tools/local-settings/': typeof ProtectedAdminInternalToolsLocalSettingsIndexRoute
  '/_protected/admin/internal-tools/merchant-descriptor-patterns/': typeof ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute
  '/_protected/admin/internal-tools/merchant-management/': typeof ProtectedAdminInternalToolsMerchantManagementIndexRoute
  '/_protected/admin/internal-tools/receipt-merchant-cleanup/': typeof ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute
  '/_protected/admin/internal-tools/receipts/': typeof ProtectedAdminInternalToolsReceiptsIndexRoute
  '/_protected/admin/internal-tools/review-receipts/': typeof ProtectedAdminInternalToolsReviewReceiptsIndexRoute
  '/_protected/admin/loyalty/$loyaltyId/': typeof ProtectedAdminLoyaltyLoyaltyIdIndexRoute
  '/_protected/admin/loyalty/add/': typeof ProtectedAdminLoyaltyAddIndexRoute
  '/_protected/admin/users/$userId/': typeof ProtectedAdminUsersUserIdIndexRoute
  '/_protected/_consumer/insights/category/$categoryName/': typeof ProtectedConsumerInsightsCategoryCategoryNameIndexRoute
  '/_protected/_consumer/insights/merchant/$merchantName/': typeof ProtectedConsumerInsightsMerchantMerchantNameIndexRoute
  '/_protected/_consumer/receipts/$receiptId/view-image/': typeof ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute
  '/_protected/admin/benefits/$benefitId/edit/': typeof ProtectedAdminBenefitsBenefitIdEditIndexRoute
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute
  '/_protected/admin/internal-tools/benefit-catalog/new/': typeof ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute
  '/_protected/admin/internal-tools/chat-history/$chatHistoryId/': typeof ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute
  '/_protected/admin/internal-tools/ledger/accounts/': typeof ProtectedAdminInternalToolsLedgerAccountsIndexRoute
  '/_protected/admin/internal-tools/ledger/new-transfer/': typeof ProtectedAdminInternalToolsLedgerNewTransferIndexRoute
  '/_protected/admin/internal-tools/ledger/transfers/': typeof ProtectedAdminInternalToolsLedgerTransfersIndexRoute
  '/_protected/admin/internal-tools/receipts/$receiptId/': typeof ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute
  '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/': typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute
  '/_protected/admin/loyalty/$loyaltyId/edit/': typeof ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute
  '/_protected/admin/users/$userId/configure-programs/': typeof ProtectedAdminUsersUserIdConfigureProgramsIndexRoute
  '/_protected/admin/users/$userId/enrich-balance/': typeof ProtectedAdminUsersUserIdEnrichBalanceIndexRoute
  '/_protected/admin/users/$userId/enrich-rewards/': typeof ProtectedAdminUsersUserIdEnrichRewardsIndexRoute
  '/_protected/admin/benefits/$benefitId/users/$userId/': typeof ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/edit/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute
  '/_protected/admin/internal-tools/ledger/accounts/$accountId/': typeof ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute
  '/_protected/admin/internal-tools/ledger/transfers/$transferId/': typeof ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute
  '/_protected/admin/internal-tools/receipts/$receiptId/edit/': typeof ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute
  '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/edit/': typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute
  '/_protected/admin/loyalty/$loyaltyId/users/$userId/': typeof ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/': typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/admin/internal-tools'
    | '/admin/'
    | '/join/$code/'
    | '/admin/users/$userId'
    | '/activity/'
    | '/api-test-proof/'
    | '/chat/'
    | '/connect-account-consent/'
    | '/identity-verification/'
    | '/insights/'
    | '/manage-accounts/'
    | '/refer-friends/'
    | '/resources/'
    | '/transaction-analytics/'
    | '/transaction-overview/'
    | '/upload-success/'
    | '/wallet/'
    | '/admin/benefits/'
    | '/admin/internal-tools/'
    | '/admin/loyalty/'
    | '/admin/users/'
    | '/receipts/capture/'
    | '/account/$accountId/'
    | '/chat/$conversationId/'
    | '/receipts/$receiptId/'
    | '/refer-friends/code/'
    | '/resources/$programId/'
    | '/transaction-overview/transfers/'
    | '/wallet/dollars/'
    | '/wallet/points/'
    | '/admin/benefits/$benefitId/'
    | '/admin/benefits/add/'
    | '/admin/internal-tools/benefit-catalog/'
    | '/admin/internal-tools/category-audit/'
    | '/admin/internal-tools/chat-history/'
    | '/admin/internal-tools/chat-prompt-editor/'
    | '/admin/internal-tools/custom-points-transaction/'
    | '/admin/internal-tools/gift-card-redemptions/'
    | '/admin/internal-tools/identity-verifications/'
    | '/admin/internal-tools/local-settings/'
    | '/admin/internal-tools/merchant-descriptor-patterns/'
    | '/admin/internal-tools/merchant-management/'
    | '/admin/internal-tools/receipt-merchant-cleanup/'
    | '/admin/internal-tools/receipts/'
    | '/admin/internal-tools/review-receipts/'
    | '/admin/loyalty/$loyaltyId/'
    | '/admin/loyalty/add/'
    | '/admin/users/$userId/'
    | '/insights/category/$categoryName/'
    | '/insights/merchant/$merchantName/'
    | '/receipts/$receiptId/view-image/'
    | '/admin/benefits/$benefitId/edit/'
    | '/admin/internal-tools/benefit-catalog/$entryId/'
    | '/admin/internal-tools/benefit-catalog/new/'
    | '/admin/internal-tools/chat-history/$chatHistoryId/'
    | '/admin/internal-tools/ledger/accounts/'
    | '/admin/internal-tools/ledger/new-transfer/'
    | '/admin/internal-tools/ledger/transfers/'
    | '/admin/internal-tools/receipts/$receiptId/'
    | '/admin/internal-tools/review-receipts/$receiptReviewId/'
    | '/admin/loyalty/$loyaltyId/edit/'
    | '/admin/users/$userId/configure-programs/'
    | '/admin/users/$userId/enrich-balance/'
    | '/admin/users/$userId/enrich-rewards/'
    | '/admin/benefits/$benefitId/users/$userId/'
    | '/admin/internal-tools/benefit-catalog/$entryId/edit/'
    | '/admin/internal-tools/ledger/accounts/$accountId/'
    | '/admin/internal-tools/ledger/transfers/$transferId/'
    | '/admin/internal-tools/receipts/$receiptId/edit/'
    | '/admin/internal-tools/review-receipts/$receiptReviewId/edit/'
    | '/admin/loyalty/$loyaltyId/users/$userId/'
    | '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/'
    | '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin'
    | '/join/$code'
    | '/activity'
    | '/api-test-proof'
    | '/chat'
    | '/connect-account-consent'
    | '/identity-verification'
    | '/insights'
    | '/manage-accounts'
    | '/refer-friends'
    | '/resources'
    | '/transaction-analytics'
    | '/transaction-overview'
    | '/upload-success'
    | '/wallet'
    | '/admin/benefits'
    | '/admin/internal-tools'
    | '/admin/loyalty'
    | '/admin/users'
    | '/receipts/capture'
    | '/account/$accountId'
    | '/chat/$conversationId'
    | '/receipts/$receiptId'
    | '/refer-friends/code'
    | '/resources/$programId'
    | '/transaction-overview/transfers'
    | '/wallet/dollars'
    | '/wallet/points'
    | '/admin/benefits/$benefitId'
    | '/admin/benefits/add'
    | '/admin/internal-tools/benefit-catalog'
    | '/admin/internal-tools/category-audit'
    | '/admin/internal-tools/chat-history'
    | '/admin/internal-tools/chat-prompt-editor'
    | '/admin/internal-tools/custom-points-transaction'
    | '/admin/internal-tools/gift-card-redemptions'
    | '/admin/internal-tools/identity-verifications'
    | '/admin/internal-tools/local-settings'
    | '/admin/internal-tools/merchant-descriptor-patterns'
    | '/admin/internal-tools/merchant-management'
    | '/admin/internal-tools/receipt-merchant-cleanup'
    | '/admin/internal-tools/receipts'
    | '/admin/internal-tools/review-receipts'
    | '/admin/loyalty/$loyaltyId'
    | '/admin/loyalty/add'
    | '/admin/users/$userId'
    | '/insights/category/$categoryName'
    | '/insights/merchant/$merchantName'
    | '/receipts/$receiptId/view-image'
    | '/admin/benefits/$benefitId/edit'
    | '/admin/internal-tools/benefit-catalog/$entryId'
    | '/admin/internal-tools/benefit-catalog/new'
    | '/admin/internal-tools/chat-history/$chatHistoryId'
    | '/admin/internal-tools/ledger/accounts'
    | '/admin/internal-tools/ledger/new-transfer'
    | '/admin/internal-tools/ledger/transfers'
    | '/admin/internal-tools/receipts/$receiptId'
    | '/admin/internal-tools/review-receipts/$receiptReviewId'
    | '/admin/loyalty/$loyaltyId/edit'
    | '/admin/users/$userId/configure-programs'
    | '/admin/users/$userId/enrich-balance'
    | '/admin/users/$userId/enrich-rewards'
    | '/admin/benefits/$benefitId/users/$userId'
    | '/admin/internal-tools/benefit-catalog/$entryId/edit'
    | '/admin/internal-tools/ledger/accounts/$accountId'
    | '/admin/internal-tools/ledger/transfers/$transferId'
    | '/admin/internal-tools/receipts/$receiptId/edit'
    | '/admin/internal-tools/review-receipts/$receiptReviewId/edit'
    | '/admin/loyalty/$loyaltyId/users/$userId'
    | '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber'
    | '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit'
  id:
    | '__root__'
    | '/_protected'
    | '/login'
    | '/_protected/_consumer'
    | '/_protected/admin'
    | '/_protected/admin/internal-tools'
    | '/_protected/_consumer/'
    | '/_protected/admin/'
    | '/join/$code/'
    | '/_protected/admin/users/$userId'
    | '/_protected/_consumer/activity/'
    | '/_protected/_consumer/api-test-proof/'
    | '/_protected/_consumer/chat/'
    | '/_protected/_consumer/connect-account-consent/'
    | '/_protected/_consumer/identity-verification/'
    | '/_protected/_consumer/insights/'
    | '/_protected/_consumer/manage-accounts/'
    | '/_protected/_consumer/refer-friends/'
    | '/_protected/_consumer/resources/'
    | '/_protected/_consumer/transaction-analytics/'
    | '/_protected/_consumer/transaction-overview/'
    | '/_protected/_consumer/upload-success/'
    | '/_protected/_consumer/wallet/'
    | '/_protected/admin/benefits/'
    | '/_protected/admin/internal-tools/'
    | '/_protected/admin/loyalty/'
    | '/_protected/admin/users/'
    | '/_protected/receipts/capture/'
    | '/_protected/_consumer/account/$accountId/'
    | '/_protected/_consumer/chat/$conversationId/'
    | '/_protected/_consumer/receipts/$receiptId/'
    | '/_protected/_consumer/refer-friends/code/'
    | '/_protected/_consumer/resources/$programId/'
    | '/_protected/_consumer/transaction-overview/transfers/'
    | '/_protected/_consumer/wallet/dollars/'
    | '/_protected/_consumer/wallet/points/'
    | '/_protected/admin/benefits/$benefitId/'
    | '/_protected/admin/benefits/add/'
    | '/_protected/admin/internal-tools/benefit-catalog/'
    | '/_protected/admin/internal-tools/category-audit/'
    | '/_protected/admin/internal-tools/chat-history/'
    | '/_protected/admin/internal-tools/chat-prompt-editor/'
    | '/_protected/admin/internal-tools/custom-points-transaction/'
    | '/_protected/admin/internal-tools/gift-card-redemptions/'
    | '/_protected/admin/internal-tools/identity-verifications/'
    | '/_protected/admin/internal-tools/local-settings/'
    | '/_protected/admin/internal-tools/merchant-descriptor-patterns/'
    | '/_protected/admin/internal-tools/merchant-management/'
    | '/_protected/admin/internal-tools/receipt-merchant-cleanup/'
    | '/_protected/admin/internal-tools/receipts/'
    | '/_protected/admin/internal-tools/review-receipts/'
    | '/_protected/admin/loyalty/$loyaltyId/'
    | '/_protected/admin/loyalty/add/'
    | '/_protected/admin/users/$userId/'
    | '/_protected/_consumer/insights/category/$categoryName/'
    | '/_protected/_consumer/insights/merchant/$merchantName/'
    | '/_protected/_consumer/receipts/$receiptId/view-image/'
    | '/_protected/admin/benefits/$benefitId/edit/'
    | '/_protected/admin/internal-tools/benefit-catalog/$entryId/'
    | '/_protected/admin/internal-tools/benefit-catalog/new/'
    | '/_protected/admin/internal-tools/chat-history/$chatHistoryId/'
    | '/_protected/admin/internal-tools/ledger/accounts/'
    | '/_protected/admin/internal-tools/ledger/new-transfer/'
    | '/_protected/admin/internal-tools/ledger/transfers/'
    | '/_protected/admin/internal-tools/receipts/$receiptId/'
    | '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/'
    | '/_protected/admin/loyalty/$loyaltyId/edit/'
    | '/_protected/admin/users/$userId/configure-programs/'
    | '/_protected/admin/users/$userId/enrich-balance/'
    | '/_protected/admin/users/$userId/enrich-rewards/'
    | '/_protected/admin/benefits/$benefitId/users/$userId/'
    | '/_protected/admin/internal-tools/benefit-catalog/$entryId/edit/'
    | '/_protected/admin/internal-tools/ledger/accounts/$accountId/'
    | '/_protected/admin/internal-tools/ledger/transfers/$transferId/'
    | '/_protected/admin/internal-tools/receipts/$receiptId/edit/'
    | '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/edit/'
    | '/_protected/admin/loyalty/$loyaltyId/users/$userId/'
    | '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/'
    | '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
  JoinCodeIndexRoute: typeof JoinCodeIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/_consumer': {
      id: '/_protected/_consumer'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedConsumerRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin': {
      id: '/_protected/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ProtectedAdminRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_consumer/': {
      id: '/_protected/_consumer/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedConsumerIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/admin/': {
      id: '/_protected/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof ProtectedAdminIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/internal-tools': {
      id: '/_protected/admin/internal-tools'
      path: '/internal-tools'
      fullPath: '/admin/internal-tools'
      preLoaderRoute: typeof ProtectedAdminInternalToolsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/join/$code/': {
      id: '/join/$code/'
      path: '/join/$code'
      fullPath: '/join/$code/'
      preLoaderRoute: typeof JoinCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/_consumer/activity/': {
      id: '/_protected/_consumer/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof ProtectedConsumerActivityIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/api-test-proof/': {
      id: '/_protected/_consumer/api-test-proof/'
      path: '/api-test-proof'
      fullPath: '/api-test-proof/'
      preLoaderRoute: typeof ProtectedConsumerApiTestProofIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/chat/': {
      id: '/_protected/_consumer/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof ProtectedConsumerChatIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/connect-account-consent/': {
      id: '/_protected/_consumer/connect-account-consent/'
      path: '/connect-account-consent'
      fullPath: '/connect-account-consent/'
      preLoaderRoute: typeof ProtectedConsumerConnectAccountConsentIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/identity-verification/': {
      id: '/_protected/_consumer/identity-verification/'
      path: '/identity-verification'
      fullPath: '/identity-verification/'
      preLoaderRoute: typeof ProtectedConsumerIdentityVerificationIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/insights/': {
      id: '/_protected/_consumer/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof ProtectedConsumerInsightsIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/manage-accounts/': {
      id: '/_protected/_consumer/manage-accounts/'
      path: '/manage-accounts'
      fullPath: '/manage-accounts/'
      preLoaderRoute: typeof ProtectedConsumerManageAccountsIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/refer-friends/': {
      id: '/_protected/_consumer/refer-friends/'
      path: '/refer-friends'
      fullPath: '/refer-friends/'
      preLoaderRoute: typeof ProtectedConsumerReferFriendsIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/resources/': {
      id: '/_protected/_consumer/resources/'
      path: '/resources'
      fullPath: '/resources/'
      preLoaderRoute: typeof ProtectedConsumerResourcesIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/transaction-analytics/': {
      id: '/_protected/_consumer/transaction-analytics/'
      path: '/transaction-analytics'
      fullPath: '/transaction-analytics/'
      preLoaderRoute: typeof ProtectedConsumerTransactionAnalyticsIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/transaction-overview/': {
      id: '/_protected/_consumer/transaction-overview/'
      path: '/transaction-overview'
      fullPath: '/transaction-overview/'
      preLoaderRoute: typeof ProtectedConsumerTransactionOverviewIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/upload-success/': {
      id: '/_protected/_consumer/upload-success/'
      path: '/upload-success'
      fullPath: '/upload-success/'
      preLoaderRoute: typeof ProtectedConsumerUploadSuccessIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/wallet/': {
      id: '/_protected/_consumer/wallet/'
      path: '/wallet'
      fullPath: '/wallet/'
      preLoaderRoute: typeof ProtectedConsumerWalletIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/admin/benefits/': {
      id: '/_protected/admin/benefits/'
      path: '/benefits'
      fullPath: '/admin/benefits/'
      preLoaderRoute: typeof ProtectedAdminBenefitsIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/internal-tools/': {
      id: '/_protected/admin/internal-tools/'
      path: '/'
      fullPath: '/admin/internal-tools/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/loyalty/': {
      id: '/_protected/admin/loyalty/'
      path: '/loyalty'
      fullPath: '/admin/loyalty/'
      preLoaderRoute: typeof ProtectedAdminLoyaltyIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/users/': {
      id: '/_protected/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof ProtectedAdminUsersIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/users/$userId': {
      id: '/_protected/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof ProtectedAdminUsersUserIdRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/receipts/capture/': {
      id: '/_protected/receipts/capture/'
      path: '/receipts/capture'
      fullPath: '/receipts/capture/'
      preLoaderRoute: typeof ProtectedReceiptsCaptureIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_consumer/account/$accountId/': {
      id: '/_protected/_consumer/account/$accountId/'
      path: '/account/$accountId'
      fullPath: '/account/$accountId/'
      preLoaderRoute: typeof ProtectedConsumerAccountAccountIdIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/chat/$conversationId/': {
      id: '/_protected/_consumer/chat/$conversationId/'
      path: '/chat/$conversationId'
      fullPath: '/chat/$conversationId/'
      preLoaderRoute: typeof ProtectedConsumerChatConversationIdIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/receipts/$receiptId/': {
      id: '/_protected/_consumer/receipts/$receiptId/'
      path: '/receipts/$receiptId'
      fullPath: '/receipts/$receiptId/'
      preLoaderRoute: typeof ProtectedConsumerReceiptsReceiptIdIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/refer-friends/code/': {
      id: '/_protected/_consumer/refer-friends/code/'
      path: '/refer-friends/code'
      fullPath: '/refer-friends/code/'
      preLoaderRoute: typeof ProtectedConsumerReferFriendsCodeIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/resources/$programId/': {
      id: '/_protected/_consumer/resources/$programId/'
      path: '/resources/$programId'
      fullPath: '/resources/$programId/'
      preLoaderRoute: typeof ProtectedConsumerResourcesProgramIdIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/transaction-overview/transfers/': {
      id: '/_protected/_consumer/transaction-overview/transfers/'
      path: '/transaction-overview/transfers'
      fullPath: '/transaction-overview/transfers/'
      preLoaderRoute: typeof ProtectedConsumerTransactionOverviewTransfersIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/wallet/dollars/': {
      id: '/_protected/_consumer/wallet/dollars/'
      path: '/wallet/dollars'
      fullPath: '/wallet/dollars/'
      preLoaderRoute: typeof ProtectedConsumerWalletDollarsIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/wallet/points/': {
      id: '/_protected/_consumer/wallet/points/'
      path: '/wallet/points'
      fullPath: '/wallet/points/'
      preLoaderRoute: typeof ProtectedConsumerWalletPointsIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/admin/benefits/$benefitId/': {
      id: '/_protected/admin/benefits/$benefitId/'
      path: '/benefits/$benefitId'
      fullPath: '/admin/benefits/$benefitId/'
      preLoaderRoute: typeof ProtectedAdminBenefitsBenefitIdIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/benefits/add/': {
      id: '/_protected/admin/benefits/add/'
      path: '/benefits/add'
      fullPath: '/admin/benefits/add/'
      preLoaderRoute: typeof ProtectedAdminBenefitsAddIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/internal-tools/benefit-catalog/': {
      id: '/_protected/admin/internal-tools/benefit-catalog/'
      path: '/benefit-catalog'
      fullPath: '/admin/internal-tools/benefit-catalog/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsBenefitCatalogIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/category-audit/': {
      id: '/_protected/admin/internal-tools/category-audit/'
      path: '/category-audit'
      fullPath: '/admin/internal-tools/category-audit/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsCategoryAuditIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/chat-history/': {
      id: '/_protected/admin/internal-tools/chat-history/'
      path: '/chat-history'
      fullPath: '/admin/internal-tools/chat-history/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsChatHistoryIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/chat-prompt-editor/': {
      id: '/_protected/admin/internal-tools/chat-prompt-editor/'
      path: '/chat-prompt-editor'
      fullPath: '/admin/internal-tools/chat-prompt-editor/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsChatPromptEditorIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/custom-points-transaction/': {
      id: '/_protected/admin/internal-tools/custom-points-transaction/'
      path: '/custom-points-transaction'
      fullPath: '/admin/internal-tools/custom-points-transaction/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsCustomPointsTransactionIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/gift-card-redemptions/': {
      id: '/_protected/admin/internal-tools/gift-card-redemptions/'
      path: '/gift-card-redemptions'
      fullPath: '/admin/internal-tools/gift-card-redemptions/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsGiftCardRedemptionsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/identity-verifications/': {
      id: '/_protected/admin/internal-tools/identity-verifications/'
      path: '/identity-verifications'
      fullPath: '/admin/internal-tools/identity-verifications/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsIdentityVerificationsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/local-settings/': {
      id: '/_protected/admin/internal-tools/local-settings/'
      path: '/local-settings'
      fullPath: '/admin/internal-tools/local-settings/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsLocalSettingsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/merchant-descriptor-patterns/': {
      id: '/_protected/admin/internal-tools/merchant-descriptor-patterns/'
      path: '/merchant-descriptor-patterns'
      fullPath: '/admin/internal-tools/merchant-descriptor-patterns/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/merchant-management/': {
      id: '/_protected/admin/internal-tools/merchant-management/'
      path: '/merchant-management'
      fullPath: '/admin/internal-tools/merchant-management/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsMerchantManagementIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/receipt-merchant-cleanup/': {
      id: '/_protected/admin/internal-tools/receipt-merchant-cleanup/'
      path: '/receipt-merchant-cleanup'
      fullPath: '/admin/internal-tools/receipt-merchant-cleanup/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/receipts/': {
      id: '/_protected/admin/internal-tools/receipts/'
      path: '/receipts'
      fullPath: '/admin/internal-tools/receipts/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReceiptsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/review-receipts/': {
      id: '/_protected/admin/internal-tools/review-receipts/'
      path: '/review-receipts'
      fullPath: '/admin/internal-tools/review-receipts/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReviewReceiptsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/loyalty/$loyaltyId/': {
      id: '/_protected/admin/loyalty/$loyaltyId/'
      path: '/loyalty/$loyaltyId'
      fullPath: '/admin/loyalty/$loyaltyId/'
      preLoaderRoute: typeof ProtectedAdminLoyaltyLoyaltyIdIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/loyalty/add/': {
      id: '/_protected/admin/loyalty/add/'
      path: '/loyalty/add'
      fullPath: '/admin/loyalty/add/'
      preLoaderRoute: typeof ProtectedAdminLoyaltyAddIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/users/$userId/': {
      id: '/_protected/admin/users/$userId/'
      path: '/'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof ProtectedAdminUsersUserIdIndexRouteImport
      parentRoute: typeof ProtectedAdminUsersUserIdRoute
    }
    '/_protected/_consumer/insights/category/$categoryName/': {
      id: '/_protected/_consumer/insights/category/$categoryName/'
      path: '/insights/category/$categoryName'
      fullPath: '/insights/category/$categoryName/'
      preLoaderRoute: typeof ProtectedConsumerInsightsCategoryCategoryNameIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/insights/merchant/$merchantName/': {
      id: '/_protected/_consumer/insights/merchant/$merchantName/'
      path: '/insights/merchant/$merchantName'
      fullPath: '/insights/merchant/$merchantName/'
      preLoaderRoute: typeof ProtectedConsumerInsightsMerchantMerchantNameIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/_consumer/receipts/$receiptId/view-image/': {
      id: '/_protected/_consumer/receipts/$receiptId/view-image/'
      path: '/receipts/$receiptId/view-image'
      fullPath: '/receipts/$receiptId/view-image/'
      preLoaderRoute: typeof ProtectedConsumerReceiptsReceiptIdViewImageIndexRouteImport
      parentRoute: typeof ProtectedConsumerRoute
    }
    '/_protected/admin/benefits/$benefitId/edit/': {
      id: '/_protected/admin/benefits/$benefitId/edit/'
      path: '/benefits/$benefitId/edit'
      fullPath: '/admin/benefits/$benefitId/edit/'
      preLoaderRoute: typeof ProtectedAdminBenefitsBenefitIdEditIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/internal-tools/benefit-catalog/$entryId/': {
      id: '/_protected/admin/internal-tools/benefit-catalog/$entryId/'
      path: '/benefit-catalog/$entryId'
      fullPath: '/admin/internal-tools/benefit-catalog/$entryId/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/benefit-catalog/new/': {
      id: '/_protected/admin/internal-tools/benefit-catalog/new/'
      path: '/benefit-catalog/new'
      fullPath: '/admin/internal-tools/benefit-catalog/new/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsBenefitCatalogNewIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/chat-history/$chatHistoryId/': {
      id: '/_protected/admin/internal-tools/chat-history/$chatHistoryId/'
      path: '/chat-history/$chatHistoryId'
      fullPath: '/admin/internal-tools/chat-history/$chatHistoryId/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/ledger/accounts/': {
      id: '/_protected/admin/internal-tools/ledger/accounts/'
      path: '/ledger/accounts'
      fullPath: '/admin/internal-tools/ledger/accounts/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsLedgerAccountsIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/ledger/new-transfer/': {
      id: '/_protected/admin/internal-tools/ledger/new-transfer/'
      path: '/ledger/new-transfer'
      fullPath: '/admin/internal-tools/ledger/new-transfer/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsLedgerNewTransferIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/ledger/transfers/': {
      id: '/_protected/admin/internal-tools/ledger/transfers/'
      path: '/ledger/transfers'
      fullPath: '/admin/internal-tools/ledger/transfers/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsLedgerTransfersIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/receipts/$receiptId/': {
      id: '/_protected/admin/internal-tools/receipts/$receiptId/'
      path: '/receipts/$receiptId'
      fullPath: '/admin/internal-tools/receipts/$receiptId/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReceiptsReceiptIdIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/': {
      id: '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/'
      path: '/review-receipts/$receiptReviewId'
      fullPath: '/admin/internal-tools/review-receipts/$receiptReviewId/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/loyalty/$loyaltyId/edit/': {
      id: '/_protected/admin/loyalty/$loyaltyId/edit/'
      path: '/loyalty/$loyaltyId/edit'
      fullPath: '/admin/loyalty/$loyaltyId/edit/'
      preLoaderRoute: typeof ProtectedAdminLoyaltyLoyaltyIdEditIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/users/$userId/configure-programs/': {
      id: '/_protected/admin/users/$userId/configure-programs/'
      path: '/configure-programs'
      fullPath: '/admin/users/$userId/configure-programs/'
      preLoaderRoute: typeof ProtectedAdminUsersUserIdConfigureProgramsIndexRouteImport
      parentRoute: typeof ProtectedAdminUsersUserIdRoute
    }
    '/_protected/admin/users/$userId/enrich-balance/': {
      id: '/_protected/admin/users/$userId/enrich-balance/'
      path: '/enrich-balance'
      fullPath: '/admin/users/$userId/enrich-balance/'
      preLoaderRoute: typeof ProtectedAdminUsersUserIdEnrichBalanceIndexRouteImport
      parentRoute: typeof ProtectedAdminUsersUserIdRoute
    }
    '/_protected/admin/users/$userId/enrich-rewards/': {
      id: '/_protected/admin/users/$userId/enrich-rewards/'
      path: '/enrich-rewards'
      fullPath: '/admin/users/$userId/enrich-rewards/'
      preLoaderRoute: typeof ProtectedAdminUsersUserIdEnrichRewardsIndexRouteImport
      parentRoute: typeof ProtectedAdminUsersUserIdRoute
    }
    '/_protected/admin/benefits/$benefitId/users/$userId/': {
      id: '/_protected/admin/benefits/$benefitId/users/$userId/'
      path: '/benefits/$benefitId/users/$userId'
      fullPath: '/admin/benefits/$benefitId/users/$userId/'
      preLoaderRoute: typeof ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/internal-tools/benefit-catalog/$entryId/edit/': {
      id: '/_protected/admin/internal-tools/benefit-catalog/$entryId/edit/'
      path: '/benefit-catalog/$entryId/edit'
      fullPath: '/admin/internal-tools/benefit-catalog/$entryId/edit/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/ledger/accounts/$accountId/': {
      id: '/_protected/admin/internal-tools/ledger/accounts/$accountId/'
      path: '/ledger/accounts/$accountId'
      fullPath: '/admin/internal-tools/ledger/accounts/$accountId/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/ledger/transfers/$transferId/': {
      id: '/_protected/admin/internal-tools/ledger/transfers/$transferId/'
      path: '/ledger/transfers/$transferId'
      fullPath: '/admin/internal-tools/ledger/transfers/$transferId/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/receipts/$receiptId/edit/': {
      id: '/_protected/admin/internal-tools/receipts/$receiptId/edit/'
      path: '/receipts/$receiptId/edit'
      fullPath: '/admin/internal-tools/receipts/$receiptId/edit/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/edit/': {
      id: '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/edit/'
      path: '/review-receipts/$receiptReviewId/edit'
      fullPath: '/admin/internal-tools/review-receipts/$receiptReviewId/edit/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/loyalty/$loyaltyId/users/$userId/': {
      id: '/_protected/admin/loyalty/$loyaltyId/users/$userId/'
      path: '/loyalty/$loyaltyId/users/$userId'
      fullPath: '/admin/loyalty/$loyaltyId/users/$userId/'
      preLoaderRoute: typeof ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/': {
      id: '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/'
      path: '/benefit-catalog/$entryId/revisions/$revisionNumber'
      fullPath: '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
    '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/': {
      id: '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/'
      path: '/benefit-catalog/$entryId/revisions/$revisionNumber/edit'
      fullPath: '/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/'
      preLoaderRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRouteImport
      parentRoute: typeof ProtectedAdminInternalToolsRoute
    }
  }
}

interface ProtectedConsumerRouteChildren {
  ProtectedConsumerIndexRoute: typeof ProtectedConsumerIndexRoute
  ProtectedConsumerActivityIndexRoute: typeof ProtectedConsumerActivityIndexRoute
  ProtectedConsumerApiTestProofIndexRoute: typeof ProtectedConsumerApiTestProofIndexRoute
  ProtectedConsumerChatIndexRoute: typeof ProtectedConsumerChatIndexRoute
  ProtectedConsumerConnectAccountConsentIndexRoute: typeof ProtectedConsumerConnectAccountConsentIndexRoute
  ProtectedConsumerIdentityVerificationIndexRoute: typeof ProtectedConsumerIdentityVerificationIndexRoute
  ProtectedConsumerInsightsIndexRoute: typeof ProtectedConsumerInsightsIndexRoute
  ProtectedConsumerManageAccountsIndexRoute: typeof ProtectedConsumerManageAccountsIndexRoute
  ProtectedConsumerReferFriendsIndexRoute: typeof ProtectedConsumerReferFriendsIndexRoute
  ProtectedConsumerResourcesIndexRoute: typeof ProtectedConsumerResourcesIndexRoute
  ProtectedConsumerTransactionAnalyticsIndexRoute: typeof ProtectedConsumerTransactionAnalyticsIndexRoute
  ProtectedConsumerTransactionOverviewIndexRoute: typeof ProtectedConsumerTransactionOverviewIndexRoute
  ProtectedConsumerUploadSuccessIndexRoute: typeof ProtectedConsumerUploadSuccessIndexRoute
  ProtectedConsumerWalletIndexRoute: typeof ProtectedConsumerWalletIndexRoute
  ProtectedConsumerAccountAccountIdIndexRoute: typeof ProtectedConsumerAccountAccountIdIndexRoute
  ProtectedConsumerChatConversationIdIndexRoute: typeof ProtectedConsumerChatConversationIdIndexRoute
  ProtectedConsumerReceiptsReceiptIdIndexRoute: typeof ProtectedConsumerReceiptsReceiptIdIndexRoute
  ProtectedConsumerReferFriendsCodeIndexRoute: typeof ProtectedConsumerReferFriendsCodeIndexRoute
  ProtectedConsumerResourcesProgramIdIndexRoute: typeof ProtectedConsumerResourcesProgramIdIndexRoute
  ProtectedConsumerTransactionOverviewTransfersIndexRoute: typeof ProtectedConsumerTransactionOverviewTransfersIndexRoute
  ProtectedConsumerWalletDollarsIndexRoute: typeof ProtectedConsumerWalletDollarsIndexRoute
  ProtectedConsumerWalletPointsIndexRoute: typeof ProtectedConsumerWalletPointsIndexRoute
  ProtectedConsumerInsightsCategoryCategoryNameIndexRoute: typeof ProtectedConsumerInsightsCategoryCategoryNameIndexRoute
  ProtectedConsumerInsightsMerchantMerchantNameIndexRoute: typeof ProtectedConsumerInsightsMerchantMerchantNameIndexRoute
  ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute: typeof ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute
}

const ProtectedConsumerRouteChildren: ProtectedConsumerRouteChildren = {
  ProtectedConsumerIndexRoute: ProtectedConsumerIndexRoute,
  ProtectedConsumerActivityIndexRoute: ProtectedConsumerActivityIndexRoute,
  ProtectedConsumerApiTestProofIndexRoute:
    ProtectedConsumerApiTestProofIndexRoute,
  ProtectedConsumerChatIndexRoute: ProtectedConsumerChatIndexRoute,
  ProtectedConsumerConnectAccountConsentIndexRoute:
    ProtectedConsumerConnectAccountConsentIndexRoute,
  ProtectedConsumerIdentityVerificationIndexRoute:
    ProtectedConsumerIdentityVerificationIndexRoute,
  ProtectedConsumerInsightsIndexRoute: ProtectedConsumerInsightsIndexRoute,
  ProtectedConsumerManageAccountsIndexRoute:
    ProtectedConsumerManageAccountsIndexRoute,
  ProtectedConsumerReferFriendsIndexRoute:
    ProtectedConsumerReferFriendsIndexRoute,
  ProtectedConsumerResourcesIndexRoute: ProtectedConsumerResourcesIndexRoute,
  ProtectedConsumerTransactionAnalyticsIndexRoute:
    ProtectedConsumerTransactionAnalyticsIndexRoute,
  ProtectedConsumerTransactionOverviewIndexRoute:
    ProtectedConsumerTransactionOverviewIndexRoute,
  ProtectedConsumerUploadSuccessIndexRoute:
    ProtectedConsumerUploadSuccessIndexRoute,
  ProtectedConsumerWalletIndexRoute: ProtectedConsumerWalletIndexRoute,
  ProtectedConsumerAccountAccountIdIndexRoute:
    ProtectedConsumerAccountAccountIdIndexRoute,
  ProtectedConsumerChatConversationIdIndexRoute:
    ProtectedConsumerChatConversationIdIndexRoute,
  ProtectedConsumerReceiptsReceiptIdIndexRoute:
    ProtectedConsumerReceiptsReceiptIdIndexRoute,
  ProtectedConsumerReferFriendsCodeIndexRoute:
    ProtectedConsumerReferFriendsCodeIndexRoute,
  ProtectedConsumerResourcesProgramIdIndexRoute:
    ProtectedConsumerResourcesProgramIdIndexRoute,
  ProtectedConsumerTransactionOverviewTransfersIndexRoute:
    ProtectedConsumerTransactionOverviewTransfersIndexRoute,
  ProtectedConsumerWalletDollarsIndexRoute:
    ProtectedConsumerWalletDollarsIndexRoute,
  ProtectedConsumerWalletPointsIndexRoute:
    ProtectedConsumerWalletPointsIndexRoute,
  ProtectedConsumerInsightsCategoryCategoryNameIndexRoute:
    ProtectedConsumerInsightsCategoryCategoryNameIndexRoute,
  ProtectedConsumerInsightsMerchantMerchantNameIndexRoute:
    ProtectedConsumerInsightsMerchantMerchantNameIndexRoute,
  ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute:
    ProtectedConsumerReceiptsReceiptIdViewImageIndexRoute,
}

const ProtectedConsumerRouteWithChildren =
  ProtectedConsumerRoute._addFileChildren(ProtectedConsumerRouteChildren)

interface ProtectedAdminInternalToolsRouteChildren {
  ProtectedAdminInternalToolsIndexRoute: typeof ProtectedAdminInternalToolsIndexRoute
  ProtectedAdminInternalToolsBenefitCatalogIndexRoute: typeof ProtectedAdminInternalToolsBenefitCatalogIndexRoute
  ProtectedAdminInternalToolsCategoryAuditIndexRoute: typeof ProtectedAdminInternalToolsCategoryAuditIndexRoute
  ProtectedAdminInternalToolsChatHistoryIndexRoute: typeof ProtectedAdminInternalToolsChatHistoryIndexRoute
  ProtectedAdminInternalToolsChatPromptEditorIndexRoute: typeof ProtectedAdminInternalToolsChatPromptEditorIndexRoute
  ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute: typeof ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute
  ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute: typeof ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute
  ProtectedAdminInternalToolsIdentityVerificationsIndexRoute: typeof ProtectedAdminInternalToolsIdentityVerificationsIndexRoute
  ProtectedAdminInternalToolsLocalSettingsIndexRoute: typeof ProtectedAdminInternalToolsLocalSettingsIndexRoute
  ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute: typeof ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute
  ProtectedAdminInternalToolsMerchantManagementIndexRoute: typeof ProtectedAdminInternalToolsMerchantManagementIndexRoute
  ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute: typeof ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute
  ProtectedAdminInternalToolsReceiptsIndexRoute: typeof ProtectedAdminInternalToolsReceiptsIndexRoute
  ProtectedAdminInternalToolsReviewReceiptsIndexRoute: typeof ProtectedAdminInternalToolsReviewReceiptsIndexRoute
  ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute
  ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute: typeof ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute
  ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute: typeof ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute
  ProtectedAdminInternalToolsLedgerAccountsIndexRoute: typeof ProtectedAdminInternalToolsLedgerAccountsIndexRoute
  ProtectedAdminInternalToolsLedgerNewTransferIndexRoute: typeof ProtectedAdminInternalToolsLedgerNewTransferIndexRoute
  ProtectedAdminInternalToolsLedgerTransfersIndexRoute: typeof ProtectedAdminInternalToolsLedgerTransfersIndexRoute
  ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute: typeof ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute
  ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute: typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute
  ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute
  ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute: typeof ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute
  ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute: typeof ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute
  ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute: typeof ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute
  ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute: typeof ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute
  ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute
  ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute: typeof ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute
}

const ProtectedAdminInternalToolsRouteChildren: ProtectedAdminInternalToolsRouteChildren =
  {
    ProtectedAdminInternalToolsIndexRoute:
      ProtectedAdminInternalToolsIndexRoute,
    ProtectedAdminInternalToolsBenefitCatalogIndexRoute:
      ProtectedAdminInternalToolsBenefitCatalogIndexRoute,
    ProtectedAdminInternalToolsCategoryAuditIndexRoute:
      ProtectedAdminInternalToolsCategoryAuditIndexRoute,
    ProtectedAdminInternalToolsChatHistoryIndexRoute:
      ProtectedAdminInternalToolsChatHistoryIndexRoute,
    ProtectedAdminInternalToolsChatPromptEditorIndexRoute:
      ProtectedAdminInternalToolsChatPromptEditorIndexRoute,
    ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute:
      ProtectedAdminInternalToolsCustomPointsTransactionIndexRoute,
    ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute:
      ProtectedAdminInternalToolsGiftCardRedemptionsIndexRoute,
    ProtectedAdminInternalToolsIdentityVerificationsIndexRoute:
      ProtectedAdminInternalToolsIdentityVerificationsIndexRoute,
    ProtectedAdminInternalToolsLocalSettingsIndexRoute:
      ProtectedAdminInternalToolsLocalSettingsIndexRoute,
    ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute:
      ProtectedAdminInternalToolsMerchantDescriptorPatternsIndexRoute,
    ProtectedAdminInternalToolsMerchantManagementIndexRoute:
      ProtectedAdminInternalToolsMerchantManagementIndexRoute,
    ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute:
      ProtectedAdminInternalToolsReceiptMerchantCleanupIndexRoute,
    ProtectedAdminInternalToolsReceiptsIndexRoute:
      ProtectedAdminInternalToolsReceiptsIndexRoute,
    ProtectedAdminInternalToolsReviewReceiptsIndexRoute:
      ProtectedAdminInternalToolsReviewReceiptsIndexRoute,
    ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute:
      ProtectedAdminInternalToolsBenefitCatalogEntryIdIndexRoute,
    ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute:
      ProtectedAdminInternalToolsBenefitCatalogNewIndexRoute,
    ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute:
      ProtectedAdminInternalToolsChatHistoryChatHistoryIdIndexRoute,
    ProtectedAdminInternalToolsLedgerAccountsIndexRoute:
      ProtectedAdminInternalToolsLedgerAccountsIndexRoute,
    ProtectedAdminInternalToolsLedgerNewTransferIndexRoute:
      ProtectedAdminInternalToolsLedgerNewTransferIndexRoute,
    ProtectedAdminInternalToolsLedgerTransfersIndexRoute:
      ProtectedAdminInternalToolsLedgerTransfersIndexRoute,
    ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute:
      ProtectedAdminInternalToolsReceiptsReceiptIdIndexRoute,
    ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute:
      ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdIndexRoute,
    ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute:
      ProtectedAdminInternalToolsBenefitCatalogEntryIdEditIndexRoute,
    ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute:
      ProtectedAdminInternalToolsLedgerAccountsAccountIdIndexRoute,
    ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute:
      ProtectedAdminInternalToolsLedgerTransfersTransferIdIndexRoute,
    ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute:
      ProtectedAdminInternalToolsReceiptsReceiptIdEditIndexRoute,
    ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute:
      ProtectedAdminInternalToolsReviewReceiptsReceiptReviewIdEditIndexRoute,
    ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute:
      ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberIndexRoute,
    ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute:
      ProtectedAdminInternalToolsBenefitCatalogEntryIdRevisionsRevisionNumberEditIndexRoute,
  }

const ProtectedAdminInternalToolsRouteWithChildren =
  ProtectedAdminInternalToolsRoute._addFileChildren(
    ProtectedAdminInternalToolsRouteChildren,
  )

interface ProtectedAdminUsersUserIdRouteChildren {
  ProtectedAdminUsersUserIdIndexRoute: typeof ProtectedAdminUsersUserIdIndexRoute
  ProtectedAdminUsersUserIdConfigureProgramsIndexRoute: typeof ProtectedAdminUsersUserIdConfigureProgramsIndexRoute
  ProtectedAdminUsersUserIdEnrichBalanceIndexRoute: typeof ProtectedAdminUsersUserIdEnrichBalanceIndexRoute
  ProtectedAdminUsersUserIdEnrichRewardsIndexRoute: typeof ProtectedAdminUsersUserIdEnrichRewardsIndexRoute
}

const ProtectedAdminUsersUserIdRouteChildren: ProtectedAdminUsersUserIdRouteChildren =
  {
    ProtectedAdminUsersUserIdIndexRoute: ProtectedAdminUsersUserIdIndexRoute,
    ProtectedAdminUsersUserIdConfigureProgramsIndexRoute:
      ProtectedAdminUsersUserIdConfigureProgramsIndexRoute,
    ProtectedAdminUsersUserIdEnrichBalanceIndexRoute:
      ProtectedAdminUsersUserIdEnrichBalanceIndexRoute,
    ProtectedAdminUsersUserIdEnrichRewardsIndexRoute:
      ProtectedAdminUsersUserIdEnrichRewardsIndexRoute,
  }

const ProtectedAdminUsersUserIdRouteWithChildren =
  ProtectedAdminUsersUserIdRoute._addFileChildren(
    ProtectedAdminUsersUserIdRouteChildren,
  )

interface ProtectedAdminRouteChildren {
  ProtectedAdminInternalToolsRoute: typeof ProtectedAdminInternalToolsRouteWithChildren
  ProtectedAdminIndexRoute: typeof ProtectedAdminIndexRoute
  ProtectedAdminUsersUserIdRoute: typeof ProtectedAdminUsersUserIdRouteWithChildren
  ProtectedAdminBenefitsIndexRoute: typeof ProtectedAdminBenefitsIndexRoute
  ProtectedAdminLoyaltyIndexRoute: typeof ProtectedAdminLoyaltyIndexRoute
  ProtectedAdminUsersIndexRoute: typeof ProtectedAdminUsersIndexRoute
  ProtectedAdminBenefitsBenefitIdIndexRoute: typeof ProtectedAdminBenefitsBenefitIdIndexRoute
  ProtectedAdminBenefitsAddIndexRoute: typeof ProtectedAdminBenefitsAddIndexRoute
  ProtectedAdminLoyaltyLoyaltyIdIndexRoute: typeof ProtectedAdminLoyaltyLoyaltyIdIndexRoute
  ProtectedAdminLoyaltyAddIndexRoute: typeof ProtectedAdminLoyaltyAddIndexRoute
  ProtectedAdminBenefitsBenefitIdEditIndexRoute: typeof ProtectedAdminBenefitsBenefitIdEditIndexRoute
  ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute: typeof ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute
  ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute: typeof ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute
  ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute: typeof ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute
}

const ProtectedAdminRouteChildren: ProtectedAdminRouteChildren = {
  ProtectedAdminInternalToolsRoute:
    ProtectedAdminInternalToolsRouteWithChildren,
  ProtectedAdminIndexRoute: ProtectedAdminIndexRoute,
  ProtectedAdminUsersUserIdRoute: ProtectedAdminUsersUserIdRouteWithChildren,
  ProtectedAdminBenefitsIndexRoute: ProtectedAdminBenefitsIndexRoute,
  ProtectedAdminLoyaltyIndexRoute: ProtectedAdminLoyaltyIndexRoute,
  ProtectedAdminUsersIndexRoute: ProtectedAdminUsersIndexRoute,
  ProtectedAdminBenefitsBenefitIdIndexRoute:
    ProtectedAdminBenefitsBenefitIdIndexRoute,
  ProtectedAdminBenefitsAddIndexRoute: ProtectedAdminBenefitsAddIndexRoute,
  ProtectedAdminLoyaltyLoyaltyIdIndexRoute:
    ProtectedAdminLoyaltyLoyaltyIdIndexRoute,
  ProtectedAdminLoyaltyAddIndexRoute: ProtectedAdminLoyaltyAddIndexRoute,
  ProtectedAdminBenefitsBenefitIdEditIndexRoute:
    ProtectedAdminBenefitsBenefitIdEditIndexRoute,
  ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute:
    ProtectedAdminLoyaltyLoyaltyIdEditIndexRoute,
  ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute:
    ProtectedAdminBenefitsBenefitIdUsersUserIdIndexRoute,
  ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute:
    ProtectedAdminLoyaltyLoyaltyIdUsersUserIdIndexRoute,
}

const ProtectedAdminRouteWithChildren = ProtectedAdminRoute._addFileChildren(
  ProtectedAdminRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedConsumerRoute: typeof ProtectedConsumerRouteWithChildren
  ProtectedAdminRoute: typeof ProtectedAdminRouteWithChildren
  ProtectedReceiptsCaptureIndexRoute: typeof ProtectedReceiptsCaptureIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedConsumerRoute: ProtectedConsumerRouteWithChildren,
  ProtectedAdminRoute: ProtectedAdminRouteWithChildren,
  ProtectedReceiptsCaptureIndexRoute: ProtectedReceiptsCaptureIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
  JoinCodeIndexRoute: JoinCodeIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
